export default "__VITE_ASSET__Bg2ElgeQ__"